import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_LOAD_BALANCE__REQUEST,
  ACTION_LOAD_BALANCE__SUCCESS,
  ACTION_LOAD_BALANCE__FAIL,
} from '../actionTypes';


const actionLoadBalanceSuccess = result => ({
  type: ACTION_LOAD_BALANCE__SUCCESS,
  payload: { result },
});

const actionLoadBalanceFail = error => ({
  type: ACTION_LOAD_BALANCE__FAIL,
  payload: { error },
});

export const actionLoadBalanceRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_BALANCE__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/webmaster/balance'
    ).then(
      result => {
        dispatch(actionLoadBalanceSuccess(result));
      },
      error => {
        dispatch(actionLoadBalanceFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
